export function isEmptyString(value: string): boolean {
    return (!Boolean(value) || value.length === 0);
}

export function trimString(value: string): string {
    return String(value).trim();
}
